import { IWithContextProps, withContext } from '@tock/coretypes';
import { IconChevronSmallLeft } from '@tock/icons';
import { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Typography } from 'omakase';
import { css } from '@emotion/react';
import Anchor from 'components/Anchor';

class AccountBackNav extends PureComponent<RouteComponentProps & IWithContextProps> {
  goBack = () => {
    this.props.history.push('/profile/reservations');
  };

  render() {
    return (
      <nav aria-label="account-nav-back" className="Account-nav is-back">
        <Anchor onClick={this.goBack}>
          <div className="Account-navItem">
            <div
              css={css`
                display: flex;
              `}
              className="Account-navArrowLeft"
            >
              <IconChevronSmallLeft />
            </div>
            <Typography color="inherit" component="span" variant="body02Strong">
              All reservations
            </Typography>
          </div>
        </Anchor>
      </nav>
    );
  }
}

export default withRouter(withContext(AccountBackNav));
